<ng-container *hasPermission="PermissionForStudents.PAYMENTS_TRANSACTIONS">
  <div class="billing-page">
    <div class="page-header">
      <div class="header-content">
        <div class="d-flex align-items-center gap-2">
          <div class="arrow" [routerLink]="'/student-dashboard/home'">
            <i class="bi bi-arrow-left-short"></i>
          </div>
          <h2>Payment & Billing</h2>
        </div>
        <p>View your payment history and download invoices</p>
      </div>
    </div>

    <div class="summary-cards">
      <div class="summary-card">
        <div class="icon purple">
          <i class="bi bi-credit-card"></i>
        </div>
        <div>
          <span class="label">Current Plan</span>
          <h4>{{ currentPlanName }}</h4>
        </div>
      </div>

      <div class="summary-card">
        <div class="icon green">
          <i class="bi bi-calendar-check"></i>
        </div>
        <div>
          <span class="label">Member Since</span>
          <h4>{{ subscriptionJoinDate | date: dateFormat }}</h4>
        </div>
      </div>

      <div class="summary-card">
        <div class="icon orange">
          <i class="bi bi-receipt"></i>
        </div>
        <div>
          <span class="label">Total Invoices</span>
          <h4>{{ totalInvoices }}</h4>
        </div>
      </div>
    </div>

    <div class="invoice-card">
      <h3><i class="bi bi-file-earmark-text test"></i> Invoice History</h3>

      <ng-container *ngIf="isLoading; else pageContent">
        <div class="app-spinner">
          <mat-spinner diameter="60"></mat-spinner>
        </div>
      </ng-container>

      <ng-template #pageContent>
        <ng-container
          *ngIf="studentTranscation.length > 0; else showTranscationMessage"
        >
          <table>
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Plan</th>
                <th>Price</th>
                <th>Date</th>
                <th>Invoice</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let transcation of studentTranscation; let i = index">
                <td data-label="S. No.">{{ (page - 1) * limit + i + 1 }}</td>
                <td data-label="Plan">
                  <i class="bi bi-gem test"></i>
                  {{ transcation.product_name || "N/A" }}
                </td>
                <td class="price" data-label="Price">
                  {{ transcation.amount_display || "N/A" }}
                </td>
                <td data-label="Date">{{ transcation.paid_date }}</td>
                <td data-label="Invoice">
                  <ng-container
                    *hasPermission="PermissionForStudents.INVOICE_DOWNLOAD"
                  >
                    <button
                      class="invoice-btn"
                      *ngIf="transcation.can_download_invoice"
                      (click)="
                        getPaymentTranscationDownload(transcation.order_id)
                      "
                    >
                      <i class="bi bi-download"></i>
                      {{ transcation.invoice_number }}
                    </button>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>

        <ng-template #showTranscationMessage>
          <p class="text-center font-name">No Transcation Available</p>
        </ng-template>
      </ng-template>
    </div>

    <div class="pagination-wrapper" *ngIf="totalRecords > limit && !isLoading">
      <button
        class="nav-btn"
        [disabled]="page === 1"
        (click)="changePage(page - 1)"
      >
        ‹
      </button>

      <div class="page-pill">
        <button
          *ngFor="let p of visiblePages"
          class="page-number"
          [class.active]="p === page"
          (click)="changePage(p)"
        >
          {{ p }}
        </button>
      </div>

      <button
        class="nav-btn"
        [disabled]="page === totalPages"
        (click)="changePage(page + 1)"
      >
        ›
      </button>
    </div>

    <div class="pagination-skeleton" *ngIf="isLoading">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</ng-container>
